import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_URL === "0"
    ? "https://digisetu.org/ccdcapiv3/v3/"
    //? "https://uat.c2mdr.com/ccdcapiv3/v3/"
    : //"https://uat.c2mdr.com/ccdcapiv3/v3/"
    // ? "http://localhost:8080/c2mydrrestuat/v1/c2mdapi/"
    "https://www.connect2mydoctor.com/c2mydrrestccdc/v1/c2mdapi/"
// "https://digisetu.org/ccdc/Connect2MyDoctorRequest";

const FILEURLs =
  process.env.REACT_APP_API_URL === "0"
    ? "https://digisetu.org/ccdc/Connect2MyDoctorRequest"
    : // "https://www.connect2mydoctor.com/ccdc/Connect2MyDoctorRequest"
    "https://uat.c2mdr.com/aravind/Connect2MyDoctorRequest";
// "https://digisetu.org/ccdc/Connect2MyDoctorRequest";
//"https://www.connect2mydoctor.com/c2mydrrestccdc/v1/c2mdapi/"
console.info("process.env.API_URL", process.env.REACT_APP_API_URL);
const loginedApi = axios.create({
  baseURL: baseURL,
});

// Request interceptor to automatically add Authorization header
loginedApi.interceptors.request.use(
  (config) => {
    const tokenStr = localStorage.getItem("AccessToken");
    if (tokenStr && tokenStr !== "undefined" && tokenStr !== "null") {
      try {
        const token = JSON.parse(tokenStr);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (e) {
        console.error("Error parsing AccessToken in request interceptor:", e);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle global errors (e.g., 401 Unauthorized)
loginedApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized! Redirecting to login...");
      localStorage.clear();
      window.location.href = "/ccdc/signin";
    }
    return Promise.reject(error);
  }
);

export default loginedApi;

export const FILEURL = FILEURLs;
export const SERVER_API_URL = baseURL;

export const c2mdApi = axios.create({
  baseURL: baseURL,
});

export const adminApi = axios.create({
  //baseURL: "https://uat.c2mdr.com/ccdcapiv3/v3/",
  baseURL: "https://digisetu.org/ccdcapiv3/v3/",
});
